var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C3.81315 17 0 13.1868 0 8.5C0 3.81324 3.81323 0 8.5 0C13.1868 0 17 3.81324 17 8.5C17 13.1868 13.1868 17 8.5 17ZM8.5 1.1648C4.44857 1.1648 1.1648 4.44836 1.1648 8.5C1.1648 12.5516 4.44836 15.8352 8.5 15.8352C12.5516 15.8352 15.8352 12.5516 15.8352 8.5C15.8352 4.44836 12.5516 1.1648 8.5 1.1648Z",
    fill: "#BF1E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5714 12.5511C11.1212 12.7895 10.168 13.0808 8.92337 13.0808C6.14301 13.0808 4.31567 11.2006 4.31567 8.36754C4.31567 5.53415 6.24872 3.46875 9.26766 3.46875C10.2475 3.46875 11.1478 3.70714 11.5978 3.94535L11.2271 5.24284C10.83 5.00445 10.1944 4.79267 9.29409 4.79267C7.17571 4.79267 6.03696 6.355 6.03696 8.28804C6.03696 10.4329 7.4139 11.7306 9.24106 11.7306C10.1943 11.7306 10.8298 11.4922 11.3066 11.2804L11.5714 12.5511Z",
    fill: "#BF1E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyC);
export default __webpack_public_path__ + "static/media/copyC.006ad3fc7ddccbd10ca4851b395e2ebc.svg";
export { ForwardRef as ReactComponent };